<template>
  <div class="introduce">
    <div class="title1" v-html="content">
    </div>
    <!-- <img
      alt=""
      src="https://api.blog.longtengl.cn/ueditor/php/upload/image/20220516/1652668220392423.jpg" /> -->
  </div>
</template>

<script>
  export default{
    name:'Introduce',
    props:{
      content:{
        type:String,
        default(){
          return ''
        }
      }
    }

  }
</script>

<style lang="scss">
  .introduce{
    line-height: 50px;
    // text-align: left;
    padding: 20px ;
    font-size: 24px;
    font-family: fantasy;
    span{
      width: 100%;
      text-align: left;
      text-indent: 2em;
    }
    .title1{
      width: 100%;
      text-align: left;
      font-size: 14px;
      margin: 2px 0;
      line-height: 50px;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/about/components/introduce.vue